import { useEffect, useState } from "react";
import logoIconLight from "@/assets/logo-icon-light.png";
import logoIconDark from "@/assets/logo-icon-dark.png";

const BOOT_MESSAGES = [
  "Connecting to Bitrix24...",
  "Checking application configurations...",
  "Preparing your workspace...",
  "Loading commissions data...",
];

export function BootScreen() {
  const [msgIdx, setMsgIdx] = useState(0);

  useEffect(() => {
    // Rotate messages every 1.5 seconds to give a sense of active progress
    const interval = setInterval(() => {
      setMsgIdx((prev) => (prev + 1) % BOOT_MESSAGES.length);
    }, 1500);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="min-h-screen relative flex items-center justify-center bg-slate-50 dark:bg-slate-950 overflow-hidden px-4 transition-colors duration-500">
      {/* Ambient glowing circles with branding colors */}
      <div className="absolute top-[-20%] left-[-10%] w-[50%] h-[50%] rounded-full bg-blue-500/10 dark:bg-blue-600/5 blur-[120px] pointer-events-none" />
      <div className="absolute bottom-[-20%] right-[-10%] w-[60%] h-[60%] rounded-full bg-[#C25B45]/10 dark:bg-[#C25B45]/5 blur-[150px] pointer-events-none" />

      {/* Grid & dot patterns with branding blue */}
      <div
        className="absolute inset-0 opacity-[0.6] dark:opacity-[0.3] pointer-events-none"
        style={{
          backgroundImage: `
            radial-gradient(circle at 1px 1px, rgba(0, 117, 255, 0.12) 1.5px, transparent 0),
            linear-gradient(to right, rgba(0, 117, 255, 0.04) 1px, transparent 1px),
            linear-gradient(to bottom, rgba(0, 117, 255, 0.04) 1px, transparent 1px)
          `,
          backgroundSize: "24px 24px",
        }}
      />

      {/* Accent diagonals using coral branding color for creative depth */}
      <div
        className="absolute inset-0 opacity-[0.08] dark:opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage: `repeating-linear-gradient(45deg, rgba(194, 91, 69, 0.1) 0px, rgba(194, 91, 69, 0.1) 2px, transparent 2px, transparent 12px)`,
        }}
      />

      <div className="relative z-10 flex flex-col items-center max-w-sm w-full space-y-10 animate-in fade-in duration-700 zoom-in-95">
        {/* Pulsing Logo */}
        <div className="relative flex items-center justify-center h-24 w-24">
          <div className="absolute inset-0 animate-ping opacity-20 rounded-full bg-primary duration-1000" />
          <div className="absolute inset-[-10px] rounded-full bg-gradient-to-tr from-primary/10 to-transparent blur-md" />
          <img
            src={logoIconLight}
            alt="BitCommissions24 Logo"
            className="block dark:hidden h-full w-full object-contain relative z-10 drop-shadow-sm"
          />
          <img
            src={logoIconDark}
            alt="BitCommissions24 Logo"
            className="hidden dark:block h-full w-full object-contain relative z-10 drop-shadow-sm"
          />
        </div>

        {/* Typography & Loading state */}
        <div className="space-y-6 w-full text-center flex flex-col items-center">
          <h1 className="text-2xl font-bold tracking-tight text-foreground">BitCommissions24</h1>

          <div className="flex flex-col items-center gap-3 w-3/4">
            {/* Elegant indeterminate progress line */}
            <div className="h-1 w-full overflow-hidden rounded-full bg-muted relative">
              <div className="absolute inset-y-0 left-0 w-full bg-primary/40 rounded-full animate-pulse" />
              <div className="absolute inset-y-0 left-0 w-1/3 bg-primary rounded-full animate-[bounce_2s_infinite]" />
            </div>

            <div className="flex items-center gap-2 text-muted-foreground mt-2">
              <span className="relative flex h-3 w-3">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-primary"></span>
              </span>
              <p className="text-sm font-medium transition-all duration-300 min-w-[200px] text-center">
                {BOOT_MESSAGES[msgIdx]}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
